import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import CustomLabel from 'components/customLabel';
import ErrorMessage from 'components/errorMessage';
import { NumericFormat } from 'react-number-format';
import { Autocomplete, Box, TextField } from '@mui/material';
import { useCurrencyQuery } from 'services/query/currency/use-currency-list';
import { SelectSumStyle, SelectSumStyle2, SelectSumStyle3 } from 'components/InitialStyle';
type ComponentType = {
  name: any;
  error: any;
  value?: any;
  control: any;
  onChange?: any;
  label?: string;
};
interface SelectOption {
  label: string;
  value: string;
}

interface Specialist {
  id: string;
  name: string;
}

const SelectSumService = ({ label, name, value, onChange, control, error }: ComponentType) => {
  const { isLoading: currencyLoading, data: currencyData } = useCurrencyQuery();

  const currencyListData = useMemo<SelectOption[]>(() => {
    const list = Array.isArray(currencyData) ? currencyData : (currencyData?.results ?? []);
    return list.map((item: Specialist) => ({
      label: item.name,
      value: item.id,
    }));
  }, [currencyData]);

  return (
    <>
      <CustomLabel htmlFor={label}>{label}</CustomLabel>
      <Box sx={{ display: 'flex' }}>
        <Controller
          name='currency'
          control={control}
          defaultValue={{ label: 'UZS', value: 1 }}
          rules={{
            required: 'Поле, обязательное для заполнения',
          }}
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              disableClearable
              sx={SelectSumStyle2}
              value={value || null}
              loading={currencyLoading}
              options={currencyListData}
              isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
              onChange={(_, values) => {
                onChange(values || null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={SelectSumStyle3}
                  error={Boolean(error?.currency)}
                  helperText={error?.currency?.message}
                />
              )}
            />
          )}
        />

        <NumericFormat
          customInput={TextField}
          type='text'
          sx={SelectSumStyle}
          error={Boolean(error?.[name])}
          value={value || ''}
          helperText={error?.[name]?.message}
          onValueChange={(values: any) => {
            onChange({ target: { name, value: values.value } });
          }}
          thousandSeparator=' '
          onWheel={(e: any) => e.target.blur()}
          InputProps={{
            inputProps: { min: 0 },
          }}
        />
      </Box>
      <ErrorMessage error={error} name={name} />
    </>
  );
};

export default SelectSumService;
